import { required, minValue, maxValue, minLength} from 'vuelidate/lib/validators'

export const amountValidator = {
    required,
    minValue: minValue(100),
}

export const fundAmountValidator = {
    required,
    minValue: minValue(100),
    maxValue: maxValue(1000000),
}

export const accountNumberValidator = {
    required,
    minLength: minLength(10),
}

export const phoneNumberValidator = {
    required,
    minLength: minLength(11),
}

export const bvnValidator = {
    required,
    minLength: minLength(11),
}

export const blockReasonValidation = {
    required,
    minLength: minLength(15),
}
